import React, { useState } from 'react';
import { ChevronDown, ShieldCheck } from 'lucide-react';

const NOTICE_IMG = '/legal/eu-legal-guarantee-notice-ro.jpg';
const QR_TARGET = 'https://europa.eu/youreurope/citizens/consumers/shopping/guarantees/index_ro.htm';

/**
 * Notificarea armonizată privind garanția legală de conformitate
 * (Regulament de punere în aplicare UE 2025/1960, obligatoriu din 27.09.2026).
 * Fișierul oficial se afișează color și nemodificat; formatul imbricat (extins la primul clic)
 * este permis explicit pentru interfețele online.
 */
export const EuGuaranteeNotice = ({ compact = false, defaultOpen = false, testId = 'eu-guarantee-notice' }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="rounded-xl border border-green-200 bg-green-50/70 overflow-hidden" data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-3 py-2.5 text-left hover:bg-green-100/60 transition-colors"
        data-testid={`${testId}-toggle`}
      >
        <ShieldCheck className="h-5 w-5 text-green-700 shrink-0" />
        <span className="flex-1 text-sm font-medium text-green-900">
          Garanție legală de conformitate — minimum 2 ani
          {!compact && <span className="block text-[11px] font-normal text-green-800/80">
            Notificarea armonizată a UE · apasă pentru detalii
          </span>}
        </span>
        <ChevronDown className={`h-4 w-4 text-green-700 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="px-3 pb-3 space-y-2" data-testid={`${testId}-content`}>
          <a href={NOTICE_IMG} target="_blank" rel="noopener noreferrer" className="block">
            <img
              src={NOTICE_IMG}
              alt="Notificarea armonizată a UE privind garanția legală de conformitate"
              className="w-full max-w-md mx-auto rounded-lg border border-green-200 bg-white"
              data-testid={`${testId}-image`}
            />
          </a>
          <p className="text-[11px] text-gray-700 leading-relaxed">
            Orice bun cumpărat în UE beneficiază de garanție legală de conformitate de minimum 2 ani.
            Dacă produsul este neconform, ai dreptul la reparare, înlocuire, reducerea prețului sau
            restituirea banilor, fără costuri.{' '}
            <a href={QR_TARGET} target="_blank" rel="noopener noreferrer"
               className="text-green-700 underline" data-testid={`${testId}-eu-link`}>
              Informații oficiale (Your Europe)
            </a>
            {' · '}
            <a href="/garantie" className="text-green-700 underline" data-testid={`${testId}-policy-link`}>
              Politica noastră de garanție
            </a>
          </p>
        </div>
      )}
    </div>
  );
};

export default EuGuaranteeNotice;
